import useSettings, { IWebsiteConfigs } from 'store/settings';
import { IGlobalSettings, IGlobalSettingsMeta } from 'api/settings';
import useGlobalSettings from 'store/globalSettings';

const useChat = () => {
  const [
    {
      data: { meta = {} as IWebsiteConfigs },
    },
  ] = useSettings();

  const [
    {
      data = {} as Partial<IGlobalSettings>,
    },
  ] = useGlobalSettings();

  const globalSettingsMeta = data.meta || ({} as IGlobalSettingsMeta);


  const openChat = () => {
    if (meta.zendeskKey) return console.log('Zendesk chat open function is not implemented');

    if (globalSettingsMeta.liveChatKey) return window.LC_API?.open_chat_window();
  };

  return { openChat };
};

export default useChat;
